import {
  WRITE_PERMISSION,
  NO_ACCESS_ROUTES
} from 'constants/account/permissions'

export const hasAccess = (permissions, permissionToCheck) => {
  // The backend uses 'write', 'read', or 'none' values for permissions.
  // Currently the access is all or nothing so both 'read' and 'none' will
  // return false.
  return !!permissions && permissions[permissionToCheck] === WRITE_PERMISSION
}

const isMatchingRoute = (pathname, route) => new RegExp(route).test(pathname)

export const isRouteGated = pathname => {
  return NO_ACCESS_ROUTES.some(route => isMatchingRoute(pathname, route))
}
